import React, { useEffect, useState } from "react";
import { TitleBar } from "../../components/TitleBar";
import { RewardsStatus } from "../../models/RewardsStatus";
import { plebsRepository } from "../../repositories/PlebsRepository";
import Loader from "./components/Loader";
import { CopyToClipboard } from "../../components/CopyToClipboard";
import { formatAmount } from "../../utils/Utils";
import { ButtonVariant } from "../../config/colors";
import { Button, ButtonSize } from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";

interface ReferralProps {}

const Referral: React.FC<ReferralProps> = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [rewardsStatus, setRewardsStatus] = useState<RewardsStatus | null>(null);

    useEffect(() => {
        const fetchRewardsStatus = async () => {
            const rewardsStatus = await plebsRepository.getRewardsStatus();
            setRewardsStatus(rewardsStatus);
            setIsLoading(false);
        };
        fetchRewardsStatus();
    }, []);

    return (
        <div className="flex-1 px-4 pt-8 overflow-hidden flex flex-col gap-8 overflow-y-auto">
            <TitleBar title={`Refer Friends & \nEarn ${
                rewardsStatus?.satsPerReferral && !isNaN(Number(rewardsStatus.satsPerReferral))
                    ? `${formatAmount(Math.floor(Number(rewardsStatus.satsPerReferral) / 1000))}K`
                    : ''
            } Sats`} />
            {isLoading ? (
                <div className="flex-1 flex items-center justify-center">
                    <Loader />
                </div>
            ) : (
                <div className="flex-1 flex flex-col gap-4">
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col justify-center items-center gap-3 bg-brand-bg-3 p-4 rounded-3xl">
                            <div className="flex flex-col gap-3 justify-center">
                                <div className="bg-brand-white rounded-lg p-4 flex justify-center items-center relative">
                                    <QRCodeCanvas
                                        value={rewardsStatus?.referralLink ?? ''}
                                        size={260}
                                        bgColor="#FFFFFF"
                                        fgColor="#000000"
                                        level="H"  // Error correction level: L, M, Q, H
                                        style={{ 
                                            maxWidth: '100%',
                                            height: 'auto',
                                            backgroundColor: "#FFFFFF",
                                            filter: "none"
                                        }}
                                    />
                                    <img 
                                        src="/logo192.png" // Adjust path to your logo
                                        alt="Logo"
                                        className="absolute w-[67px] h-[67px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-white  p-1"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col gap-2 justify-center items-center shrink-1">
                                <CopyToClipboard toCopy={rewardsStatus?.referralLink ?? ''} className="max-w-[280px] text-center" classNameCopied="w-full text-center">
                                    <span className="break-words [word-wrap:anywhere] pr-2">{rewardsStatus?.referralLink ?? ''}</span>
                                    <i 
                                        className="material-icons text-[18px]"
                                        title="Copy to clipboard"
                                    >
                                        file_copy
                                    </i>
                                </CopyToClipboard>
                            </div>
                        </div>
                        <div className="flex flex-col gap-2 bg-brand-bg-3 p-4 rounded-3xl">
                            <div className="flex flex-col gap-2 justify-center items-center">
                                <div><span className="font-bold text-xl">{formatAmount(rewardsStatus?.totalReferred ?? 0)}</span> people referred</div>
                            </div>
                            <div className="flex flex-col gap-2 justify-center items-center">
                                <div><span className="font-bold text-xl">{formatAmount(rewardsStatus?.totalPendingReferrals ?? 0)}</span> pending referrals</div>
                            </div>
                            <div className="flex flex-col gap-2 justify-center items-center mt-3">
                                <Button 
                                    variant={ButtonVariant.primary} 
                                    size={ButtonSize.small}
                                    onClick={() => {
                                        navigate('/home/wallet');
                                    }}
                                >
                                    Referrals are paid directly to your wallet
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Referral;